<template>
	<div class="container">
		<Header />

		<div class="banner">
			<div class="tab-bar">
				<div class="tab-title h2">线下体验网点</div>
				<div>
					<ServiceCity
						selTitel="线下体验网点"
						:list="mainList"
						@onSelctCity="onSelctCity"
					/>
				</div>
			</div>
			<div
				class="top-content"
				v-if="(page.cityCode === '310100' || !page.cityCode) && shop.shopName"
			>
				<img
					class="left-img"
					src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210618171946470-71349762.jpg"
				/>

				<div class="right-view">
					<div class="right-title h2">{{ shop.shopName }}</div>
					<div class="right-title1 h4">
						{{ shop.experienceAddr }}
					</div>
					<div class="right-title2 h4">{{ shop.telephone }}</div>
				</div>
			</div>

			<StoreList :list="storeList" />
		</div>

		<div v-if="page.noMore" style="height: 36px"></div>
		<div v-if="!page.noMore" class="more-btn" @click="getMore">查看更多</div>
		<Floor :absolute="true" />
	</div>
</template>

<script>
import Floor from '@components/Floor/index.vue'
import Header from '@components/Header/index.vue'
import ServiceCity from '@components/ServiceCity'
import StoreList from '@components/StoreList'
import { getCityList, getOfflineStore } from '@api/store'
export default {
	name: 'offline-store',
	components: {
		Floor,
		Header,
		ServiceCity,
		StoreList,
	},
	data() {
		return {
			storeList: [],
			mainList: [],
			page: {
				cityCode: null,
				current: 1,
				size: 50,
				noMore: true,
			},
			shop: {},
		}
	},
	created() {
		getCityList('').then((resp) => {
			this.mainList = resp.data || []
			this.getStoreList(null, 1)
		})
	},
	methods: {
		onSelctCity(item) {
			this.page.cityCode = item.authorizeCityAdCode
			this.page.current = 1
			this.page.noMore = true
			this.shop = {}
			this.getStoreList(this.page.cityCode, this.page.current)
		},
		// 查看更多
		getMore() {
			this.page.current += 1
			this.getStoreList(this.page.cityCode, this.page.current)
		},
		getStoreList(cityCode, pageIndex) {
			getOfflineStore({
				authorizeCityAdCode: cityCode || null,
				pageIndex: pageIndex,
				pageSize: this.page.size,
			}).then((resp) => {
				let list = []
				if (pageIndex == 1) {
					list = [...resp.data.records]
				} else {
					list = [...this.storeList, ...resp.data.records]
				}
				this.storeList = list

				if (this.page.cityCode === '310100' || !this.page.cityCode) {
					let shopIndex = list.findIndex((v) => v.shopName == '合创上海旗舰店')
					if (shopIndex > -1) {
						this.shop = list.splice(shopIndex, 1)[0]
					}
				}

				if (this.page.current >= resp.data.pages) {
					this.page.noMore = true
				} else {
					this.page.noMore = false
				}
			})
		},
	},
}
</script>
<style lang="scss">
@import '@style/base';
@import '@style/common';
html,
body {
	background-color: #f6f7f8;
	min-height: 100vh;
	position: relative;
}
.container {
	overflow: hidden;
}
@include setMedia($lg) {
	@include setThemeClass {
		.banner {
			margin: 0 auto;
			width: $md;
			.tab-bar {
				display: flex;
				justify-content: space-between;
				margin-top: 42px;
				align-items: center;
			}
		}

		.city-content-outer {
			position: relative;
			margin-top: 30px;
			z-index: 1;
			@include media(
				(
					$md: (
						height: 220px,
					),
				)
			);
			.city-content-inner {
				background-color: getThemeVal(backgroundColorWhite);
				&.is-shown {
					@include media(
						(
							$lg: (
								box-shadow: 0px 24px 24px 0px rgba(0, 0, 0, 0.08),
							),
							$md: (
								position: absolute,
								top: 0,
								left: 0,
								right: 0,
							),
						)
					);
				}
				.city-content {
					position: relative;
					display: flex;
					height: auto;
					max-height: 170px;
					width: $lg;
					justify-content: center;
					border-radius: 4px;
					overflow-y: hidden;
					&.is-shown {
						overflow-y: auto;
						min-height: 170px;
						max-height: 300px;
					}
				}

				.more-content {
					background-color: getThemeVal(backgroundColorWhite);
					height: 50px;
					display: flex;
					align-items: center;
					justify-content: center;
					.more-content-inner {
						cursor: pointer;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					.showmore-icon {
						margin-left: 6px;
						width: 14px;
						height: 14px;
					}
					.showmore {
						text-align: center;
					}
				}
			}
		}

		.top-content {
			width: $md;
			height: 420px;
			background-color: getThemeVal(backgroundColorWhite);
			border-radius: 4px;
			margin-top: 24px;
			flex-direction: row;
			display: flex;
			.left-img {
				width: 560px;
				height: 420px;
				border-radius: 4px 0px 0px 4px;
			}
			.right-view {
				width: 472px;
				height: 420px;
				.right-title {
					margin: 24px 30px 0 30px;
				}
				.right-title1 {
					margin: 20px 30px 0 30px;
				}
				.right-title2 {
					margin: 10px 30px 0 30px;
				}
			}
		}

		.more-btn {
			margin-left: auto;
			margin-right: auto;
			margin-bottom: 60px;
			margin-top: 48px;
			@include subTextButtonFixed(getThemeVal(brandColorBlack));
		}
	}
}

@include setMedia($md) {
	@include setThemeClass {
		.banner {
			width: $sm;
		}
		.top-content {
			width: $sm;
			height: $sm;
			flex-direction: column;
			.left-img {
				width: $sm;
				height: 534px;
				border-radius: 4px 4px 0px 0px;
			}
			.right-view {
				width: $sm;
				height: 180px;
				.right-title {
					margin: 20px 20px 0 20px;
				}
				.right-title1 {
					margin: 20px 20px 0 20px;
				}
				.right-title2 {
					margin: 10px 20px 0 20px;
				}
			}
		}
	}
}

@include setMedia($sm) {
	@include setThemeClass {
		.banner {
			width: auto;
			margin-left: 20px;
			margin-right: 20px;
		}

		.top-content {
			width: 100%;
			height: 460px;
			display: flex;
			margin-top: 24px;
			.left-img {
				width: 100%;
				height: 251px;
			}
			.right-view {
				width: 100%;
				height: 209px;
			}
		}
	}
}
</style>
